import { AccountStates } from '@interfaces/account';

export const CLOSED_ACCOUNT_STATES = [
  AccountStates.CANCELED,
  AccountStates.INACTIVE,
  AccountStates.FAILED,
];
